/* OsPlanCatalogImagesRenderer.js */

"use strict";
const Forms = require("@gluenetworks/forms");
const _ = require("lodash");
const { IMAGE_TYPES_FILTER } = require("../../../../../../../lmrbcomponents/fileexplorer/fileConstants");

const FormsComponent = Forms.ui.component;
//const PickListControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Multiple.PickList;

class OsPlanCatalogImagesRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("os-plan-catalog-images-gl");
        this._formsComponent = new FormsComponent();
        this._registerListeners();

        this._addButtonIcon = document.createElement("base-icon-gl");
        this._addButtonIcon.setAttribute("class", "btn-icon-chevron-right");
        this._addButtonIcon.dataset.icon = "common.chevron";
        this._prevPatchLength = undefined;
        this.imageEntities = undefined;
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._formsComponent.on(
            "PendingPatchesChanged",
            (this._onFormsPendingPatchesChanged = _.debounce(this._onFormsPendingPatchesChanged.bind(this), 500, false))
        );
    }

    _unregisterListeners() {
        this._formsComponent.removeListener("PendingPatchesChanged", this._onFormsPendingPatchesChanged);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    render() {
        return this.model.whenModelIsReady().then(() => {
            this._rootElem.appendChild(this._formsComponent.renderer.rootElement);
            this._prevPatchLength = this.model._selectedImagesLength;
            this._renderImagesView();
        });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }

    shutdown() {
        this._unregisterListeners();
        return this._formsComponent
            .shutdown()
            .then(() => {
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._formsComponent = undefined;
                this._prevPatchLength = undefined;
                this.imageEntities = undefined;
            })
            .catch((err) => {
                console.error(err);
            });
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    _renderImagesView() {
        this._pristineValues = {
            pickList: this._getPristineValues().map((item) => item.id)
        };
        this._getJtype().then((jtype) => {
            // List of ids which are coming from server and not available in the Catalog.
            // This is done in order to add these additional ids in the picklist
            jtype.pickList = _.concat(jtype.pickList, _.differenceWith(this._pristineValues.pickList, jtype.pickList, _.isEqual));

            if (!_.isEmpty(this._model._imageDetailsView._patchesCreated)) {
                _.forEach(this._model._imageDetailsView._patchesCreated, (item) => {
                    if (item.op === "add" || item.op === "replace") {
                        if (_.isEmpty(jtype.pickList) || _.isEmpty(jtype.pickList.filter((image) => image === item.id))) {
                            jtype.pickList.push(item.id);
                        }
                    } else {
                        jtype.pickList = jtype.pickList.filter((image) => image !== item.id);
                    }
                });
            }

            // List of labels which are coming from server and not available in the Catalog.
            // This is done in order to add these additional labels in the picklist
            const additionalLabels = this._getPristineValues()
                .map((item) => item.name)
                .filter((item) => {
                    if (!jtype["pickList@Display.pickList.labels"].includes(item) && !_.isEmpty(item)) {
                        return true;
                    }
                });
            jtype["pickList@Display.pickList.labels"] = _.concat(jtype["pickList@Display.pickList.labels"], additionalLabels);

            if (!_.isEmpty(this._model._imageDetailsView._patchesCreated)) {
                _.forEach(this._model._imageDetailsView._patchesCreated, (item) => {
                    if (item.op === "add" || item.op === "replace") {
                        if (
                            _.isEmpty(jtype["pickList@Display.pickList.labels"]) ||
                            _.isEmpty(jtype["pickList@Display.pickList.labels"].filter((image) => image === item.id))
                        ) {
                            jtype["pickList@Display.pickList.labels"].push({
                                id: item.id,
                                name: item.name
                            });
                        }
                    } else {
                        jtype["pickList@Display.pickList.labels"] = jtype["pickList@Display.pickList.labels"].filter((image) => image.id !== item.id);
                    }
                });
            }
            this.imageEntities = []
                .concat(this._model._images, this._model._selectedImages)
                .map((img) => {
                    const imageType = IMAGE_TYPES_FILTER[img.getImageType()] || "DEFAULT";
                    const name = `${img.getName()} (${imageType.title || "Unknown"})`;
                    return {
                        id: img.id,
                        name
                    };
                })
                .concat(this._model._imageDetailsView._patchesCreated);

            this.selImageIds = _.concat(
                [],
                this._pristineValues.pickList,
                this._model._selectedImages.map((img) => {
                    return img.id;
                })
            );
            if (!_.isEmpty(this._model._imageDetailsView._imageSortOrder)) {
                const sortingResult = this._applySorting(jtype.pickList, jtype["pickList@Display.pickList.labels"]);
                jtype.pickList = sortingResult.arrayIds;
                this._pristineValues.pickList = sortingResult.arrayIds.filter((id) => {
                    if (this.selImageIds.indexOf(id) >= 0) {
                        return true;
                    }
                    return false;
                });
                jtype["pickList@Display.pickList.labels"] = sortingResult.arrayLabels;
            }
            this._formsComponent.setTypeInformation(jtype, true);
            this._formsComponent.setPristineValue(this._pristineValues, true);
            return this._formsComponent.renderer.render().then(() => {
                return Promise.resolve();
            });
        });
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onFormsPendingPatchesChanged(patches) {
        if (!this._formsComponent) {
            return;
        }

        const form = this._formsComponent.getValue();

        const unionArray = _.union(
            form.pickList,
            _.get(this._model._osPlan.getPristineProperties(), "_pristineProperties.imageAssociations." + this._model._key + ".imageIds")
        );

        if (this._prevPatchLength < form.pickList.length) {
            let protocol = this.model._imageDetailsView.renderer._transferProtocol.getValue();

            this.model._osPlan.associateImagesToKey(this.model._key, protocol, form.pickList).then(() => {
                this._updateGenericPatches();
            });
        } else if (this._prevPatchLength > form.pickList.length && !_.isNull(this._formsComponent.getPendingPatches())) {
            let removedImages = _.differenceWith(this._formsComponent.getPristineValue().pickList, unionArray);

            this.model._osPlan.removeImagesForAssociationKey(this.model._key, removedImages).then(() => {
                this._updateGenericPatches();
            });
        } else if (patches && patches.filter((item) => item.op === "replace").length > 0) {
            // Sorting changed
            let protocol = this.model._imageDetailsView.renderer._transferProtocol.getValue();
            this.model._osPlan.associateImagesToKey(this.model._key, protocol, form.pickList).then(() => {
                this._updateGenericPatches();
            });
        }
        this._prevPatchLength = form.pickList.length;
    }

    _toggleDirtyForm(isDirty) {
        this._model._gameEditor._tabCmpnt.setDirty(isDirty, false);
        this._model._imageDetailsView._renderer._toggleAction(isDirty);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _getJtype() {
        return this._getPicklistLabels().then((pickListLabels) => {
            pickListLabels = pickListLabels || [];
            let pickListValues = [];
            if (!_.isEmpty(this.imageEntities)) {
                pickListValues = this.imageEntities
                    .sort((a, b) => {
                        return pickListLabels.indexOf(_.get(a, "label", "")) - pickListLabels.indexOf(_.get(b, "label", ""));
                    })
                    .map((item) => item.id);
            } else {
                pickListValues = this._getImageIds(this.model._images);
            }

            return {
                "pickList@Display.label": "Images",
                "pickList@Display.pickList": {
                    minLineCount: 8,
                    labels: [],
                    optionsLabel: "",
                    selectedLabel: "",
                    hideOptionFilter: false
                },
                "pickList@Display.pickList.labels": pickListLabels,
                pickList: pickListValues
            };
        });
    }

    _updateGenericPatches() {
        if (!_.isEmpty(this._formsComponent.getValue())) {
            this._model._imageDetailsView._imageSortOrder = this._formsComponent.getValue().pickList;
        } else {
            this._model._imageDetailsView._imageSortOrder = [];
        }

        let oldPatches = this._model._imageDetailsView._patchesCreated;
        this._model._imageDetailsView._patchesCreated = [];
        let currentImages = _.isEmpty(_.get(this._model._osPlan.getPristineProperties().imageAssociations, this._model._key, []))
            ? []
            : _.get(this._model._osPlan.getPristineProperties().imageAssociations, this._model._key, []).imageIds;

        let imagesAdded = _.differenceWith(this._formsComponent.getValue().pickList, currentImages);

        let imagesRemoved = _.differenceWith(currentImages, this._formsComponent.getValue().pickList);

        if (!_.isEmpty(imagesAdded)) {
            imagesAdded.map((item) => {
                if (_.isEmpty(this._model._imageDetailsView._patchesCreated.filter((currentItem) => currentItem.id === item.id))) {
                    this._model._imageDetailsView._patchesCreated.push({
                        id: item,
                        name: this._getImageNameFromId(item, oldPatches),
                        op: "add"
                    });
                }
            });
        }
        if (!_.isEmpty(imagesRemoved)) {
            imagesRemoved.map((item) => {
                if (_.isEmpty(this._model._imageDetailsView._patchesCreated.filter((currentItem) => currentItem.id === item.id))) {
                    this._model._imageDetailsView._patchesCreated.push({
                        id: item,
                        name: this._getImageNameFromId(item, oldPatches),
                        op: "remove"
                    });
                }
            });
        }
    }

    _getImageNameFromId(imageId, oldPatches) {
        if (
            !_.isEmpty(
                _.get(
                    _.get(
                        oldPatches.filter((item) => item.id === imageId),
                        "0",
                        []
                    ),
                    "id",
                    []
                )
            )
        ) {
            return _.get(
                _.get(
                    oldPatches.filter((item) => item.id === imageId),
                    "0",
                    []
                ),
                "name",
                []
            );
        }
        const index = _.get(this._formsComponent._jtype, "pickList").indexOf(imageId);
        return _.get(this._formsComponent._jtype, "pickList@Display.pickList.labels", "")[index];
    }

    _getPicklistLabels() {
        return this._getImageNamesFromModel();

        /* Case 24489 - To be code reviewed
        if (!this._model._osPlan.isDirty()) {
            return this._getImageNamesFromModel();
        } else {
            if (!_.isEmpty(this._pristineValues.pickList)) {
                return this._model._imageDetailsView._osImageEntity
                    .loadOsImages(
                        this._model._gameEditor._activeOrgId,
                        { id: { $in: this._pristineValues.pickList } },
                        { fileName: true },
                        undefined,
                        undefined
                    )
                    .then((images) => {
                        images.sort((a, b) => {
                            return (
                                this._pristineValues.pickList.indexOf(_.get(a, "_id", "")) -
                                this._pristineValues.pickList.indexOf(_.get(b, "_id", ""))
                            );
                        });

                        this.imageEntities = images.map((item) => {
                            return {
                                id: _.get(item, "_id", ""),
                                label: _.get(item, "pristineProperties.fileName", "")
                            };
                        });
                        return Promise.resolve(images.map((item) => _.get(item, "pristineProperties.fileName", "")));
                    });
            } else if (!_.isEmpty(this.model._images)) {
                return this._getImageNamesFromModel();
            }
        }
        return Promise.resolve([]);
        */
    }

    _getImageNamesFromModel() {
        return Promise.resolve().then(() => {
            return this.model._images.map((image) => {
                const imageType = IMAGE_TYPES_FILTER[image.getImageType()] || "DEFAULT";

                return `${image.getName()} (${imageType.title || "Unknown"})`; // update to this
                // return `${image.getName()}`;
            });
        });
    }

    _getImageIds(images) {
        return images.map((image) => {
            return image.id;
        });
    }

    _applySorting(arrayIds, arrayLabels) {
        if (!_.isEmpty(this._model._imageDetailsView._imageSortOrder)) {
            arrayIds.sort((a, b) => {
                return this._model._imageDetailsView._imageSortOrder.indexOf(a) - this._model._imageDetailsView._imageSortOrder.indexOf(b);
            });

            // arrayLabels = this.imageEntities
            //     .sort((a, b) => {
            //         return (
            //             this._model._imageDetailsView._imageSortOrder.indexOf(_.get(a, "id")) -
            //             this._model._imageDetailsView._imageSortOrder.indexOf(_.get(b, "id"))
            //         );
            //     })
            //     .map((item) => item.label);
            arrayLabels = arrayIds.map((id) => {
                const obj = _.find(this.imageEntities, { id });
                return obj.name;
            });
            return { arrayIds, arrayLabels };
        } else {
            return { arrayIds, arrayLabels };
        }
    }

    _getPristineValues() {
        let selectedImages = [];

        // return `${image.getName()} (${imageType.title || 'Unknown'})`;
        if (_.isEmpty(this._model._imageDetailsView._patchesCreated)) {
            selectedImages = this._getImagesFromModel();
        } else {
            this.model._selectedImages.forEach((image) => {
                const imageType = IMAGE_TYPES_FILTER[image.getImageType()] || "DEFAULT";
                if (
                    _.get(this._model._osPlan, "_pristineProperties.imageAssociations." + this._model._key + ".imageIds", []).includes(
                        _.get(image, "id")
                    )
                ) {
                    selectedImages.push({
                        id: image.id,
                        name: `${_.get(image, "pristineProperties.fileName", "")} (${imageType.title || "Unknown"})`
                    });
                }
            });

            if (!_.isEmpty(this._model._imageDetailsView._patchesCreated)) {
                _.forEach(this._model._imageDetailsView._patchesCreated, (item) => {
                    if (item.op === "add" || item.op === "replace") {
                        if (_.isEmpty(selectedImages) || _.isEmpty(selectedImages.filter((image) => image.id === item.id))) {
                            selectedImages.push({ id: item.id, name: item.name });
                        }
                    } else {
                        selectedImages = selectedImages.filter((image) => image.id !== item.id);
                    }
                });
            }
        }

        return selectedImages;
    }

    _getImagesFromModel() {
        let selectedImages = [];

        const imageIdsFromModel = _.get(this._model._osPlan, "_pristineProperties.imageAssociations." + this._model._key + ".imageIds", []);
        if (imageIdsFromModel) {
            imageIdsFromModel.forEach((imageId) => {
                const idx = this._model._selectedImages.findIndex((item) => item.id === imageId);
                if (idx < 0) {
                    return;
                }
                const img = this._model._selectedImages[idx];
                const imageType = IMAGE_TYPES_FILTER[img.getImageType()] || "DEFAULT";
                const name = `${img.getName()} (${imageType.title || "Unknown"})`;
                selectedImages.push({
                    id: imageId,
                    name: name
                });
            });
        }
        return selectedImages;
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = OsPlanCatalogImagesRenderer;
